import {
  useAPIQuery,
  UserAccountApi,
} from "melco-shared-logic";

export const useSubscriptionGetPendingChanges = (
  userSubscriptionId: string
  ,
  enabled: boolean
) => {

  return useAPIQuery(UserAccountApi, ["softwareLicensesPendingChanges", userSubscriptionId], async (api) => {
    if (userSubscriptionId == null) {
      return;
    }

    return api.subscriptionGetPendingChanges({ userSubscriptionId: userSubscriptionId });
  }
    , {
      queryOptions: {
        enabled: enabled && !!userSubscriptionId
      }
    });
};
